import { render } from "./CustomInput.vue?vue&type=template&id=0d2b5023"
import script from "./CustomInput.vue?vue&type=script&lang=js"
export * from "./CustomInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__